export const getValueFromSearch = (name: string) => {
  try {
    const params = new URLSearchParams(location.search);
    return params.get(name) ?? undefined;
  } catch (e) {
    return undefined;
  }
};
